'use strict';

/**
 * message
 */
export const message = (() => {
    const $toggle = $('.js-message-toggle');
    const $message = $('.js-message');
    let $wWidth = 0;
    let tcr_pos = 0;

    $(window).on('load resize', function () {
        $wWidth = $(window).outerWidth();
    });

    const toggle = () => {
        if (!$('body').hasClass('is-show-message')) {
            tcr_pos = $(window).scrollTop();
            $('.js-wraper').css('top', '-' + tcr_pos + 'px')
        }

        setTimeout(() => {
            $('body').toggleClass('is-show-message');
            $message.toggleClass('is-visible');

            if ($('body').hasClass('is-show-message')) {
                window.scrollTo(0, 0);
            } else {
                window.scrollTo(0, tcr_pos);
            }
        }, 10);
    };

    const init = () => {
        $toggle.on('click', event => {
            if ($wWidth <= 768) {
                toggle();
            }
        });
    };

    return {
        init: init
    };
})();
